module.exports = __webpack_public_path__ + "img/banner02_info_S_2.ac60737e.png";